import { Component, computed, input } from '@angular/core'
import { DatoImageDirective } from '@naturalcycles/ngx-lib'
import { LINK } from '@src/app/cnst/links.cnst'

@Component({
  selector: 'app-illustration',
  templateUrl: './illustration.component.html',
  styleUrls: ['./illustration.component.scss'],
  imports: [DatoImageDirective],
})
export class IllustrationComponent {
  protected src = input.required<string>()
  protected alt = input.required<string>()
  protected width = input<number>(520)

  protected isDatoImage = computed(() => this.src().startsWith(LINK.DATO_CMS_ASSETS_URL))
}
